<template>
  <div>
    <v-row v-if="scenarios && scenarios.length">
      <v-col cols="12" class="pt-3 content-container">
        <div>
          <span class="details-heading application-heading pull-left mr-3"
            >Scenarios</span
          >
          <v-select
            v-model="selectedType"
            class="pull-right pt-0 mr-2 scenario-types"
            :items="scenarioTypes"
            :width="200"
            hide-details
          ></v-select>
          <div class="clearfix"></div>
        </div>

        <v-card class="mt-2 pa-3">
          <div v-if="scenario" class="mb-3">
            <p class="mt-2 mb-5 sub-title application-heading">
              {{ scenario.Title }}
            </p>
            <p class="mt-2 mb-5">
              <i>{{ getFormattedDate(scenario) }}</i>
            </p>
            <div class="sub-title">Overview</div>
            <div
              v-if="scenario.Overview"
              v-html="getCleanBody(scenario.Overview)"
            ></div>
            <div class="sub-title">Developments</div>
            <div
              v-if="scenario.Developments"
              class="my-3"
              v-html="getCleanBody(scenario.Developments)"
            ></div>
            <!--
            <div class="sub-title my-3">Issues</div>
            <div>
              <div v-for="riskRating in scenario.RiskRatings" :key="riskRating.RiskCategory">
                <div
                  class="pull-left risk-rating-container application-heading text-center mr-3"
                  :style="getRiskRatingStyle(riskRating.Rating)"
                >{{ riskRating.Rating }}</div>
                <div class="pull-left"><b>{{ riskRating.RiskCategory }}</b></div>
                <div class="clearfix"></div>
                <div class="mb-2">{{ riskRating.Summary }}</div>
              </div>
            </div>
            -->
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import lodashFind from "lodash/find";

import { RISK_LEVELS } from "@/common/constants/controlRisks/risks";
import { addTargetToLinks } from "@/common/basic.utilities";
import { getFormatted } from "@/common/date.utilities";

export default {
  name: "RisksScenarios",
  components: {},
  props: {
    background: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedType: "Most Likely",
    };
  },
  computed: {
    scenario() {
      let scenario = null;
      if (this.background.Scenarios) {
        scenario = lodashFind(this.background.Scenarios, [
          "ScenarioType",
          this.selectedType,
        ]);
      }
      return scenario;
    },
    scenarios() {
      if (
        this.background &&
        this.background.Scenarios &&
        Array.isArray(this.background.Scenarios)
      ) {
        return this.background.Scenarios;
      }
      return null;
    },
    scenarioTypes() {
      if (this.scenarios && this.scenarios.length) {
        const types = [];
        this.scenarios.forEach((scenario) => {
          if (scenario.ScenarioType) {
            types.push(scenario.ScenarioType);
          }
        });
        return types;
      }
      return null;
    },
  },
  methods: {
    getFormattedDate(scenario) {
      if (scenario.PublishDate) {
        return getFormatted(scenario.PublishDate);
      }
      return null;
    },
    getCleanBody(body) {
      if (body) {
        return addTargetToLinks(body);
      }
      return "";
    },
    getRiskRatingStyle(rating) {
      const level = lodashFind(RISK_LEVELS, ["name", rating]);
      return {
        "background-color": level && level.bgColor ? level.bgColor : "gray",
        color: level && level.fontColor ? level.fontColor : "black",
      };
    },
  },
  watch: {},
  beforeDestroy() {},
};
</script>

<style scoped>
.details-heading {
  font-size: 20px;
}
.content-container {
  max-width: 530px !important;
  font-size: 14px;
}
.scenario-title {
  font-size: 14px;
  cursor: pointer;
}
.sub-title {
  font-size: 16px;
}
.scenario-types {
  position: relative;
  top: -10px;
  width: 200px !important;
}
.risk-rating-container {
  width: 80px;
  height: 24px;
  font-size: 12px;
}
</style>
